import React, { Component } from "react";
import { Link } from "@reach/router";
import {
  Card,
  Button,
  ButtonGroup,
  Collapse,
  Container,
  Row,
  Col,
} from "reactstrap";

import { FormHeader, TableSearchInput, UpDownCaretArrow } from "components";

import TrashImage from "images/trashcan.svg";

class Contacts extends Component {
  state = {
    isCollapse: false,
    searchText: "",
  };

  handleInputChange = (event) => {
    event.preventDefault();
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  handleBackButton = () => {
    return window.history.back();
  };

  handleToggle = () => {
    this.setState((prevState) => ({ isCollapse: !prevState.isCollapse }));
  };

  render() {
    const { isCollapse } = this.state;

    return (
      <div>
        <Card className="login-form__card card-table">
          <FormHeader title={"Contacts"} className=" mb-0">
            <button
              type="button"
              className="btn"
              onClick={this.handleBackButton}
            >
              Back
            </button>
          </FormHeader>
          <hr />
          <div className="card-table__midsection">
            <div className="midsecton-1">
              <TableSearchInput
                value={this.state.searchText}
                name="searchText"
                placeholder="Filter"
                onChange={this.handleInputChange}
              />
            </div>
            <div className="midsecton-2">
              <Link to="/new-contact">
                <Button className="secondary-btn">New Contact</Button>
              </Link>
            </div>
          </div>

          <div className="card-table__mainsection">
            <Container>
              <Row className="data-header">
                <Col className="data-type">Name</Col>
                <Col className="data-type">Mobile Number</Col>
                <Col className="data-type"> Email</Col>
                <Col className="data-type">&nbsp;</Col>
              </Row>

              <Row className="data-subheader" onClick={this.handleToggle}>
                <Col className="data-type">Harrion Jide</Col>
                <Col className="data-type" xs="auto">
                  <UpDownCaretArrow isCollapse={isCollapse} />
                </Col>
              </Row>
              <Collapse isOpen={isCollapse}>
                <Row className="data-row">
                  <Col className="data-type">&nbsp;</Col>
                  <Col className="data-type">081 239 4837</Col>
                  <Col className="data-type">example@gmail.com</Col>
                  <Col className="data-type">
                    <ButtonGroup className="secondary-btn">
                      <Button className="secondary-btn">Edit</Button>
                      <Button className="secondary-btn">
                        <img src={TrashImage} alt="" />
                      </Button>
                    </ButtonGroup>
                  </Col>
                </Row>
              </Collapse>
            </Container>
          </div>
        </Card>
      </div>
    );
  }
}

export default Contacts;
